module.exports = __webpack_public_path__ + "media/images/favicons/favicon-30a54311e4b09a631c6180c87a0ab324.ico";